<div class="w-100 text-center"> 
  <img src="../../../../assets/img/404.svg" class="col-sm-2 mx-auto d-block" alt="1">
  <h2 class="text-center">We can't find the page you're looking for!</h2>
</div>

